export default "__VITE_ASSET__BaeinyXq__"